var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieceLength({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1765864992723,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1267,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M686.634667 85.546667c-30.101333 0-60.181333 11.392-82.986667 34.154666L119.722667 603.669333c-45.546667 45.546667-45.546667 120.405333 0 165.973334l134.677333 134.656c45.546667 45.546667 120.405333 45.546667 165.973333 0L904.32 420.266667c45.546667-45.546667 45.525333-120.362667-0.042667-165.909334L769.621333 119.68a117.056 117.056 0 0 0-82.986666-34.154667z m0 63.573333c13.568 0 27.2 5.290667 37.76 15.829333l134.656 134.677334a32 32 0 0 0 0 0.042666c21.12 21.12 21.098667 54.272 0 75.370667L375.082667 859.050667a52.906667 52.906667 0 0 1-75.456 0l-134.677334-134.677334a52.906667 52.906667 0 0 1 0-75.456l27.392-27.328 52.053334 52.053334a32 32 0 1 0 45.226666-45.269334l-52.053333-52.053333 61.44-61.397333 73.024 73.045333a32 32 0 1 0 45.269333-45.269333l-73.045333-73.024 61.418667-61.44 52.053333 52.053333a32 32 0 1 0 45.226667-45.226667l-52.053334-52.053333 61.44-61.44 73.024 73.066667a32 32 0 1 0 45.269334-45.269334l-73.045334-73.024 91.328-91.392a53.162667 53.162667 0 0 1 37.717334-15.829333zM736 256a32 32 0 0 0 0 64 32 32 0 0 0 0-64z",
    fill: "#a1a0a2",
    "p-id": 1268
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieceLength);
export default __webpack_public_path__ + "static/media/piece-length.61284e3c3c9e8b9b067131a94c6f7988.svg";
export { ForwardRef as ReactComponent };